export enum NotificationType {
    CLIENT = 1,
    DRIVER = 2,
    PHARMACISTS = 3,
    ALL = 4,
    NEW_CLIENT = 5,
    INVESTOR_GUEST = 6,
    GUEST = 7
}

export const getNotificationColor = (status: NotificationType) => {
    switch (status) {
        case NotificationType.ALL:
            return "green";
        case NotificationType.CLIENT:
            return "red";
        case NotificationType.DRIVER:
            return "blue";
        case NotificationType.PHARMACISTS:
            return "orange";
        case NotificationType.NEW_CLIENT:
            return "purple";
        case NotificationType.INVESTOR_GUEST:
            return "orange";
        case NotificationType.GUEST:
            return "purple";
        default:
            return "red";
    }
};

// Status Boolean stuts
export const getNotificationType = (status: NotificationType) => {
    switch (status) {
        case NotificationType.ALL:
            return "all";
        case NotificationType.CLIENT:
            return "client";
        case NotificationType.DRIVER:
            return "driver";
        case NotificationType.PHARMACISTS:
            return "pharmacist";
        case NotificationType.NEW_CLIENT:
            return "new_client";
        case NotificationType.INVESTOR_GUEST:
            return "investor_guest";
        case NotificationType.GUEST:
            return "guest";
        default:
            return "driver";
    }
};
